/*
  T9 support centre.
  - "Did this fix it?": Yes thanks the reader and pushes a support_helpful event to the dataLayer; No follows its link.
  - The GHL support form gets the robot and, from ?issue= (No, I need help) or ?q= (search), the question filled in.
  - Support search now runs on /search (assets/search.js: Support tab, robot scope, highlights, quick answer);
    this file still handles "Did this fix it?" there.
  - "Chat now" shows only when the GHL chat widget is on the page, and opens it.
*/
(() => {
  const params = new URLSearchParams(window.location.search);

  document.addEventListener('click', (e) => {
    const yes = e.target.closest('[data-helped-yes]');
    if (!yes) return;
    const box = yes.closest('[data-helped]');
    box.querySelectorAll('[data-helped-yes], [data-helped-no]').forEach((el) => { el.hidden = true; });
    box.querySelector('[data-helped-thanks]').hidden = false;
    (window.dataLayer = window.dataLayer || []).push({ event: 'support_helpful', helpful: 'yes', support_item: box.dataset.label });
  });
  document.addEventListener('click', (e) => {
    const no = e.target.closest('[data-helped-no]');
    if (!no) return;
    (window.dataLayer = window.dataLayer || []).push({ event: 'support_helpful', helpful: 'no', support_item: no.closest('[data-helped]').dataset.label });
  });

  // Support form prefill
  document.querySelectorAll('[data-support-form]').forEach((box) => {
    const url = new URL(box.dataset.src);
    if (box.dataset.modelKey && box.dataset.model) url.searchParams.set(box.dataset.modelKey, box.dataset.model);
    const issue = params.get('issue') || params.get('q');
    if (box.dataset.issueKey && issue) url.searchParams.set(box.dataset.issueKey, issue);
    const frame = box.querySelector('iframe');
    if (frame && url.toString() !== frame.src) frame.src = url.toString();
  });

  // Robot support page menu: underline the section on screen (T9DesktopRobot)
  const tabs = [...document.querySelectorAll('.sup-tabs a[href^="#"]')];
  const targets = tabs.map((t) => document.getElementById(t.hash.slice(1))).filter(Boolean);
  if (targets.length && 'IntersectionObserver' in window) {
    const mark = (id) => tabs.forEach((t) => t.setAttribute('aria-current', String(t.hash === `#${id}`)));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) mark(en.target.id); });
    }, { rootMargin: '-20% 0px -70% 0px' });
    targets.forEach((t) => io.observe(t));
  }

  // GHL chat button
  const chat = () => window.leadConnector && window.leadConnector.chatWidget;
  const showChat = () => document.querySelectorAll('[data-support-chat]').forEach((b) => { b.hidden = !chat(); });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-support-chat]') || !chat()) return;
    chat().openWidget();
  });
  showChat();
  window.addEventListener('load', () => setTimeout(showChat, 2500));
})();

/* YouTube in support articles and Older models: a linked thumbnail until clicked, then a youtube-nocookie
   player. Without JS (or on the old theme) it stays a plain link to the video. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('a.yt-lite');
  if (!link || link.querySelector('iframe')) return;
  // The ID comes from data-yt, or from the link itself if Shopify's editor dropped the attribute
  const id = link.dataset.yt || new URL(link.href).searchParams.get('v');
  if (!id) return;
  event.preventDefault();
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;
  iframe.title = link.getAttribute('aria-label') || 'Video';
  iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
  iframe.allowFullscreen = true;
  link.append(iframe);
});
